export default {
  data: function () {
    return {
      makehomedesktop: [{
        target: '.step-0-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">1 / 7</span>'
        },
        content: "Let's get started with the <strong>Explore</strong> tab. This is a feed of the latest public projects created by the Make: Projects community",
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.step-1-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">2 / 7</span>'
        },
        content: 'Already know what you’re looking for? Use the search to find <strong>projects</projects> and <strong>users</strong> that match your interests.'
      },
      {
        target: '.step-2-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">3 / 7</span>'
        },
        content: 'This is where you start your own project. You can make it either private or public depending on your goals and what you’re trying to achieve.'
      },
      {
        target: '.step-3-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">4 / 7</span>'
        },
        content: 'This is your <strong>customized feed</strong> based on the categories you follow. Modify anytime by clicking the personalize button',
        offset: -100,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.step-4-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">5 / 7</span>'
        },
        content: 'Like a Project you see? Click <strong>Bookmark</strong> to save it for later in your user account dropdown on the top right of this page.',
        offset: -100,
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.step-5-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">6 / 7</span>'
        },
        content: '<strong>My Projects</strong> is your dashboard to quickly access and jump back into the projects you’re working on'
      },
      {
        target: '.step-6-makehome-obd',
        header: {
          title: '<span>_____<span> <span class="numbers">7 / 7</span>'
        },
        content: "This is where you can direct message others in the community, either individually or in a group chat. <br>You're all set to start, happy project making!</br>"
      }],
      makehomemobile: [{
        target: '.step-0-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">1 / 6</span>'
        },
        content: 'This is your launch pad to <strong>explore projects</strong> from makers all over the world. View categories at a glance and find additional resources. Check out projects, help out fellow makers and get inspiration for your own work!'
      },
      {
        target: '.step-1-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">2 / 6</span>'
        },
        content: 'Already know what you’re looking for? Use the search to find <strong>projects</projects> and <strong>users</strong> that match your interests.'
      },
      {
        target: '.step-2-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">3 / 6</span>'
        },
        content: 'Click here to <strong>learn more</strong> about projects and to <strong>start</strong> your very first project.'
      },
      {
        target: '.step-3-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">4 / 6</span>'
        },
        offset: -100,
        content: 'Below is your <strong>customized feed</strong> based on the topics you selected during sign up. You can modify them anytime by clicking the <strong>personalize</strong> button to the right.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.step-4-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">5 / 6</span>'
        },
        offset: -100,
        content: 'Like a Project you see? Click <strong>Bookmark</strong> to save it for later in your user account dropdown on the top right of this page.',
        params: {
          placement: 'bottom'
        }
      },
      {
        target: '.step-5-makehome-obm',
        header: {
          title: '<span>_____<span> <span class="numbersmobile">6 / 6</span>'
        },
        content: "This is where you can direct message others in the community, either individually or in a group chat. <br>You're all set to start, happy project making!</br>"
      }]
    }
  }
}
